/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateContentEventRequest, CreateContentEventRequests } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Content<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name EventsCreate
   * @request POST:/content/{contentId}/events
   */
  eventsCreate = (contentId: string, data: CreateContentEventRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/content/${contentId}/events`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name EventsBatchCreate
   * @request POST:/content/{contentId}/events-batch
   */
  eventsBatchCreate = (contentId: string, data: CreateContentEventRequests, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/content/${contentId}/events-batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
